import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import CustomTable from "../../CustomTable";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get_tasks } from "../../../redux/tasks/actions";


const FuncionesModal = ({ showFormModal, setShowFormModal, funcionesList, setFuncionesList }) => {
    const dispatch = useDispatch();
    const [selectedFuncion, setSelectedFuncion] = useState([]);
    const [searchFuncion, setSearchFuncion] = useState("");

    const {
        tasks,
        loader: loadingTasks
    } = useSelector((store) => store.tasks);

    const tasksOptions = tasks?.map((task) => ({
        id: task.id,
        label: `${task.codigo} / ${task.descripcion}`
    })) || [];

    const {
        loading: loadingConfSmartEmpleados
    } = useSelector((store) => store.confSmart);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchFuncion !== "") {
                dispatch(get_tasks({ filter: searchFuncion }, 2));
            }
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchFuncion]);

    const funcionesColumns = [
        {
            Header: "Función",
            accessor: "label"
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <Button
                    variant="outline-danger"
                    className="rounded-pill"
                    disabled={loadingConfSmartEmpleados}
                    onClick={() => {
                        let newFuncionesList = funcionesList.filter(f => f.id !== value.row.original.id);
                        setFuncionesList(newFuncionesList);
                    }}
                >
                    <i className="material-icons">close</i>
                </Button>
            )
        }
    ]

    return (
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)} size="lg" centered>

            <Form>
                <Modal.Header closeButton>
                    <Modal.Title className="ft-modal-title">
                        Selección de Función
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form.Group as={Col} className="mb-1">
                        <Form.Label column sm="12" md="12">
                            Función
                        </Form.Label>
                        <Row>
                            <Col sm={10} className="mb-3">
                                <Typeahead
                                    id="funcion"
                                    name="funcion"
                                    placeholder="Seleccione una función"
                                    selected={selectedFuncion}
                                    disabled={loadingTasks || loadingConfSmartEmpleados}
                                    options={tasksOptions}
                                    onChange={(selected) => {
                                        if (selected[0]?.id) {
                                            let funcionExists = funcionesList.some(f => f.id === selected[0].id);
                                            if (!funcionExists) {
                                                let newFuns = [...funcionesList, selected[0]];
                                                setFuncionesList(newFuns);
                                                setSearchFuncion("");
                                                setSelectedFuncion([]);
                                            }
                                        }


                                    }}
                                    onInputChange={(input) => {
                                        setSearchFuncion(input);
                                    }}

                                />
                            </Col>
                            {loadingTasks && (
                                <Col sm={2} className="text-right">
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </Col>
                            )}
                        </Row>
                        <h5 className="mb-3 mt-4">Funciones Seleccionadas</h5>
                        <Row>
                            <CustomTable
                                columns={funcionesColumns}
                                data={funcionesList}
                            />

                        </Row>
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="rounded-pill"
                        variant="secondary"
                        onClick={() => setShowFormModal(false)}
                    >
                        Cerrar
                    </Button>

                </Modal.Footer>
            </Form>

        </Modal>

    )
}

export default FuncionesModal;